import { Component, DOCUMENT, inject, OnInit, signal } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { ScriptsManagerService } from '../../../../shared/services/scripts-manager/scripts-manager.service';
import { AuthenticationService } from '../../../../shared/services/authentication/authentication.service';
import { SafeUrlPipe } from '../../../../shared/pipes/safe-url/safe-url.pipe';
import { UserModel } from '../../../../shared/models/core/auth.models';
import { ApiService } from '../../../../shared/services/api/api.service';
import { LocalStorageKeys } from '../../../../shared/models/core/storage.models';
import { firstValueFrom } from 'rxjs';
import { MainRoutes } from '../../../../shared/models/core/routes.models';
import { SharedExternalModule } from 'desy-angular';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  imports: [SafeUrlPipe, SharedExternalModule]
})
export class LoginComponent implements OnInit {
  private readonly router = inject(Router);
  protected readonly authenticationService = inject(AuthenticationService);
  private readonly auroraService = inject(ApiService);
  private readonly document = inject(DOCUMENT);

  protected readonly mfeUrl: string;
  protected readonly loadingToken = signal(false);

  constructor() {
    const redirectUrl = btoa(`${this.document.location.origin}/${MainRoutes.LOGIN}`);
    this.mfeUrl = `${environment.integration_url}/mfe_core/rest/identification/HAL/${redirectUrl}`;
    window['onIdentification'] = this.identificacionMFE.bind(this);
  }

  ngOnInit(): void {
    if (this.authenticationService.getLocalStorageUser()) {
      void this.router.navigate([MainRoutes.HOME]);
    } else {
      this.authenticationService.handleLogout();
      ScriptsManagerService.AddMfeLoginScript();
    }
  }

  async identificacionMFE(operation: UserModel) {
    if (!operation?.jwt || !operation?.eIdentifier) return;

    this.loadingToken.set(true);
    try {
      const userData = await firstValueFrom(
        this.auroraService.validateToken({
          nif: operation.eIdentifier,
          org: operation.organismCode,
          token: operation.jwt
        })
      );

      userData.orgCode = operation.organismCode;
      userData.orgName = operation.organismName;

      localStorage.setItem(LocalStorageKeys.CURRENT_USER, JSON.stringify(userData));
      AuthenticationService.User.set(userData);
      void this.router.navigate([MainRoutes.HOME]);
    } catch {
      this.document.location.reload();
    }
  }
}
